var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrawler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.025,
    height: 42.031,
    viewBox: "0 0 64.025 42.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M38.5,37.6h.3V36.1a3.478,3.478,0,0,0-3.5-3.5h-6V29.4c.1-3.1.2-5.6-2-8L21,14.5A8.3,8.3,0,0,0,15.3,12H8.1a.945.945,0,0,0-1,1V33.6a.367.367,0,0,0,.1.3,3.5,3.5,0,0,0-.8,2.2v1.7a9.853,9.853,0,0,1,1.7-.2ZM12.3,18.2a.908.908,0,0,1,.3-.7,1.135,1.135,0,0,1,.8-.3H15a4.317,4.317,0,0,1,3.8,1.1c1.4,1.6,2.5,2.7,3.3,3.5,1.6,1.6,2.3,2.3,2.3,3.8v2.6a1,1,0,0,1-1,1H13.5a1,1,0,0,1-1-1v-10ZM64.5,52c-5-2.9-7.1-5.8-7-9.5a1.025,1.025,0,0,0-1-1H51.9a1.05,1.05,0,0,0-.9.5l-1.8,3.8H45.5a7.1,7.1,0,0,0-7-6.1H8.1a7.1,7.1,0,1,0,0,14.2H38.5a7.033,7.033,0,0,0,7-6.1h2.8a4.1,4.1,0,0,0-.1,1.1c0,7.6,13.4,4.3,15.8,5h0a1.2,1.2,0,0,0,1-.7A1.023,1.023,0,0,0,64.5,52ZM8.4,50.6a3.7,3.7,0,0,1,0-7.4,3.757,3.757,0,0,1,3.7,3.7A3.691,3.691,0,0,1,8.4,50.6Zm9.8,0a3.7,3.7,0,1,1,3.7-3.7A3.691,3.691,0,0,1,18.2,50.6Zm9.9,0a3.7,3.7,0,1,1,3.7-3.7A3.757,3.757,0,0,1,28.1,50.6Zm9.8,0a3.7,3.7,0,1,1,3.7-3.7A3.757,3.757,0,0,1,37.9,50.6Z",
    transform: "translate(-1 -12)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrawler);
export default __webpack_public_path__ + "static/media/crawler.f4c097aeaaf58f2d7fcb7fd8d728d7ea.svg";
export { ForwardRef as ReactComponent };